import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ActionIcon, Box, Group, Switch } from '@mantine/core';
import { IconGripVertical, IconX } from '@tabler/icons-react';
import TextInput from 'src/components/design-system/input/TextInput';
import { FieldConfig } from '../types';

type FieldItemProps = {
  field: FieldConfig;
  onToggleVisible: () => void;
  onLabelChange: (label: string | null) => void;
};

export default function FieldItem({ field, onToggleVisible, onLabelChange }: FieldItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: field.entityFieldName,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const hasCustomLabel = field.label !== null && field.label !== '';

  return (
    <Group
      ref={setNodeRef}
      style={style}
      gap="sm"
      px="md"
      py="xs"
      wrap="nowrap"
      bg={field.visible ? undefined : 'gray.0'}
      opacity={field.visible ? 1 : 0.5}
    >
      <IconGripVertical
        size={16}
        style={{ cursor: 'grab', flexShrink: 0, color: 'var(--mantine-color-gray-5)' }}
        {...attributes}
        {...listeners}
      />
      <Box style={{ flex: 1 }}>
        <TextInput
          placeholder={field.defaultLabel}
          value={field.label ?? ''}
          onChange={e => onLabelChange(e.currentTarget.value || null)}
        />
      </Box>
      {hasCustomLabel && (
        <ActionIcon variant="subtle" size="xs" color="gray" onClick={() => onLabelChange(null)}>
          <IconX size={12} />
        </ActionIcon>
      )}
      <Switch
        size="xs"
        checked={field.visible}
        onChange={onToggleVisible}
        label={field.visible ? 'Visible' : 'Hidden'}
        styles={{
          label: {
            fontSize: 'var(--mantine-font-size-xs)',
            color: field.visible ? undefined : 'var(--mantine-color-dimmed)',
          },
        }}
      />
    </Group>
  );
}
